import { useAuth } from '../context/AuthContext';

export default function PlanoModal({ onClose, onLogin }) {
  const { user } = useAuth();
  const uid = user?.uid || '';

  // Link Asaas com UID como referência externa
  const linkAsaas = `https://www.asaas.com/c/pnd90p2l55ziuicn?externalReference=${uid}`;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 999,
      background: 'rgba(0,0,0,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}
      onClick={e => e.target === e.currentTarget && onClose()}>

      <div style={{
        background: '#fff', borderRadius: '20px', padding: '40px 36px',
        width: '420px', textAlign: 'center',
        boxShadow: '0 24px 80px rgba(0,0,0,0.25)'
      }}>

        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚀</div>

        <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800',
          fontSize: '22px', marginBottom: '10px', letterSpacing: '-0.5px' }}>
          Faça seu plano agora
        </h2>

        <p style={{ color: '#52526e', fontSize: '14px', lineHeight: '1.7',
          marginBottom: '28px' }}>
          Para usar essa ferramenta você precisa de um plano ativo.
          Acesso completo por apenas{' '}
          <strong style={{ color: '#6c47ff' }}>R$89,90/mês</strong>.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px',
          marginBottom: '28px', textAlign: 'left', padding: '0 8px' }}>
          {[
            '✅ Extrator Google Maps ilimitado',
            '✅ Extrator Instagram',
            '✅ Disparo humanizado por IA',
            '✅ Agendamentos automáticos',
            '✅ Calculadora de propostas grátis',
            '✅ Migrador de planilhas',
          ].map(item => (
            <div key={item} style={{ fontSize: '13px', color: '#0a0a18' }}>{item}</div>
          ))}
        </div>

        <a href={linkAsaas} target="_blank" rel="noopener noreferrer"
          style={{ display: 'block', textDecoration: 'none' }}>
          <button style={{
            width: '100%', padding: '14px',
            background: 'linear-gradient(135deg, #6c47ff, #5535e0)',
            color: '#fff', border: 'none', borderRadius: '12px',
            fontSize: '15px', fontWeight: '700', cursor: 'pointer',
            boxShadow: '0 6px 20px rgba(108,71,255,0.4)',
            marginBottom: '10px'
          }}>
            Assinar agora — R$89,90/mês →
          </button>
        </a>

        {!user && (
          <button onClick={onLogin}
            style={{
              width: '100%', padding: '12px', background: 'none',
              border: '1.5px solid rgba(0,0,0,0.1)', borderRadius: '12px',
              fontSize: '14px', fontWeight: '600', cursor: 'pointer',
              color: '#52526e', marginBottom: '10px'
            }}>
            Já tenho uma conta — Entrar
          </button>
        )}

        <button onClick={onClose}
          style={{ background: 'none', border: 'none', fontSize: '12px',
            color: '#9898b8', cursor: 'pointer', marginTop: '4px' }}>
          Fechar
        </button>

        <div style={{ marginTop: '16px', fontSize: '11px', color: '#9898b8' }}>
          Sem fidelidade · Cancele quando quiser
        </div>
      </div>
    </div>
  );
}